/** Tendly domain enums — must match CHECK constraints in migration 00041. */

export const ASSET_KINDS = ["car", "motorcycle", "home", "appliance", "other"] as const;
export type AssetKind = (typeof ASSET_KINDS)[number];

export const USAGE_UNITS = ["km", "hours", "none"] as const;
export type UsageUnit = (typeof USAGE_UNITS)[number];

export const SERVICE_CATEGORIES = [
  "maintenance",
  "repair",
  "inspection",
  "insurance",
  "tax",
  "upgrade",
  "other",
] as const;
export type ServiceCategory = (typeof SERVICE_CATEGORIES)[number];

/** Default usage unit based on asset kind. */
export const DEFAULT_USAGE_UNIT_BY_KIND: Record<AssetKind, UsageUnit> = {
  car: "km",
  motorcycle: "km",
  home: "none",
  appliance: "none",
  other: "none",
};

export function isAssetKind(value: string): value is AssetKind {
  return (ASSET_KINDS as readonly string[]).includes(value);
}

export function isServiceCategory(value: string): value is ServiceCategory {
  return (SERVICE_CATEGORIES as readonly string[]).includes(value);
}

export function isUsageUnit(value: string): value is UsageUnit {
  return (USAGE_UNITS as readonly string[]).includes(value);
}
